<template>
  <b-modal
    ref="kycModal"
    v-model="modalVisible"
    size="xl"
    scrollable
    :hide-header-close="true"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    hide-footer
    :title="modalTitle"
  >
    <profile-kyc
      :back="true"
      :pending="pending"
      :rejected="rejected"
      :useractivity-prop="localUserData.useractivity"
      :require-digital-signature="needsAgreementSignature"
      @saved="onKycSaved"
    />
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import ProfileKyc from '@/views/pages/profile/ProfileKyc.vue'
import axios from '@/components/axios'

export default {
  name: 'KycPendingModal',
  components: {
    BModal,
    ProfileKyc,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalVisible: false,
      localUserData: {},
      pending: false,
      rejected: false,
      pollTimer: null,
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
    }
  },
  computed: {
    modalTitle() {
      if (this.pending) return 'Your KYC is Pending'
      if (this.rejected) return 'Your KYC has been Rejected'
      return 'Please Update Your KYC'
    },
    needsAgreementSignature() {
      return (
        this.localUserData?.role === 'companyassociatepartner' &&
        !this.isUserApproved(this.localUserData?.approved) &&
        !this.hasAgreementSignature(this.localUserData?.agreement_signature)
      )
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.modalVisible = val
        if (val) {
          this.$nextTick(() => {
            this.refreshUserData()
            this.startPolling()
          })
        } else {
          this.stopPolling()
        }
      },
    },
    modalVisible(val) {
      this.$emit('update:show', val)
      if (!val) this.stopPolling()
    },
    userData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length) {
          this.localUserData = { ...val }
          this.updateKycState()
        }
      },
    },
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    isUserApproved(approved) {
      return approved === true || approved === 1 || approved === '1'
    },
    hasAgreementSignature(signature) {
      return !!(signature && String(signature).trim())
    },
    updateKycState() {
      const isKyc = this.localUserData.is_kyc
      this.pending = isKyc === 0 || isKyc === '0'
      this.rejected = isKyc === 2 || isKyc === '2'
    },
    isFullyComplete(user) {
      const kycDone = user.is_kyc == 1 || user.role === 'employee'
      const agreementDone =
        user.role !== 'companyassociatepartner' ||
        this.isUserApproved(user.approved) ||
        this.hasAgreementSignature(user.agreement_signature)
      return kycDone && agreementDone
    },
    onKycSaved() {
      localStorage.aggrement = true
      this.localUserData.approved = true
      localStorage.setItem('userData', JSON.stringify(this.localUserData))
      this.$emit('agreement-signed', this.localUserData)
      this.refreshUserData()
    },
    async refreshUserData() {
      if (!this.userData?.id) return
      try {
        const response = await axios({
          method: 'GET',
          url: `${this.baseApi}/getusersbyid/${this.userData.id}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        const fresh = response.data?.data?.[0] || response.data?.data || response.data
        if (fresh) {
          this.localUserData = fresh
          this.updateKycState()
          if (this.isFullyComplete(fresh)) {
            this.closeModal(fresh)
          }
        }
      } catch (err) {
        console.error('Failed to refresh user data', err)
      }
    },
    closeModal(user) {
      this.modalVisible = false
      this.$emit('kyc-complete', user)
      this.stopPolling()
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        this.refreshUserData()
      }, 10000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
  },
}
</script>
